import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import appLogo from "assets/logo/logo-only.png";
import rapidImg from "assets/images/transaction-rapid.png";
import EMPaymentPageSuccess from "../components/EMPaymentSuccess";
import EMPaymentPage from "../components/EMPaymentPage";
import EMToolBar from "../components/EMToolbar";
import "./index.scss";

const EMManageMachine = () => {
  const { status } = useParams();
  const history = useHistory();
  const [currentStep, setCurrentStep] = useState(1);
  const handleStep = (e) => {
    setCurrentStep(e);
  };
  return (
    <div className="rapid-booking">
      <EMToolBar step={currentStep} />
      <sidebar className="side-bar">
        <img
          data-testid="app-logo"
          className="app-logo"
          src={appLogo}
          alt="alt"
          onClick={() => history.push("/")}
          aria-hidden
        />
        <div className="backdrop-image">
          <img
            data-testid="transaction-img"
            className="rapid-image"
            src={rapidImg}
            alt="alt"
          />
        </div>
      </sidebar>
      {status !== "success" ? (
        <EMPaymentPage step={currentStep} handleNext={handleStep} />
      ) : (
        <EMPaymentPageSuccess />
      )}
    </div>
  );
};

export default EMManageMachine;
